export default {
  title: '编辑职位自定义字段',
  menu: '编辑职位自定义字段',
  label: {
    cnName: '中文名',
    enName: '英文名',
    type: '类型',
    status: '状态',
    required: '必填',
    select: '多选',
    text: '单行文本',
    single: '单选',
    textarea: '多行文本',
    date: '日期',
    addJobFilter: '新建职位自定义字段',
    editJobFilter: '编辑职位自定义字段',
    cnFieldLabel: '字段值 (中文)',
    enFieldLabel: '字段值 (英文)',
    fieldType: '字段类型',
    cnFieldValue: '字段值 (中文)',
    enFieldValue: '字段值 (英文)',
    addOption: '新增字段值',
    editOption: '编辑字段值',
    visibleOnlyMember: '仅职位创建人和协作人可见'
  },
  placeholder: {
    cnFieldLabel: '请输入字段值 (中文)',
    enFieldLabel: '请输入字段值 (英文)',
    cnFieldValue: '请输入字段值 (中文)',
    enFieldValue: '请输入字段值 (英文)',
    fieldType: '请选择字段类型'
  },
  message: {
    deleteOption: '您确定要删除字段值 {cnName}-{name}？'
  }
}
